module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Thanks as always to Rose Hilliard and Rachel Vater, editor and agent supreme. To the team at St. Martin’s who worked tirelessly to make this the best book possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Team Seattle, for friendship, trips to the gun range, and zombie-themed parties.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("All of my blog readers, who provide endless procrastination on slow days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jackie, Sara, and Stacia, who never once rolled their eyes when I complained about my deadlines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thanks as always to Agent Heidi Wallace of the ATF for her endless patience and infinite knowledge of firearms and law enforcement procedure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Most of all, to every single reader of the Nocturne City series, those of you who make Luna and her world much bigger than me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thank you all.")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/map.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d139c4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 72
// module chunks = 0